import React from 'react';
import { RouteObject } from 'react-router-dom';
import MainPage from './Pages/MainPage/MainPage';
import SignInPage from './Pages/AuthPages/SignInPage/SignInPage';
import SignUpPage from './Pages/AuthPages/SignUpPage/SignUpPage';
import SignOutPage from './Pages/AuthPages/SignOutPage/SignOutPage';
import { urlManager } from './Utils/URL/URLManager';
import AdminPage from './Pages/Admin/AdminPage/AdminPage';
import AdminUsersPage from './Pages/Admin/AdminUsersPage/AdminUsersPage';
import ForgotPasswordPage from './Pages/AuthPages/ForgotPasswordPage/ForgotPasswordPage';
import RecoveryPasswordPage from './Pages/AuthPages/RecoveryPasswordPage/RecoveryPasswordPage';

const routes: RouteObject[] = [
  { path: urlManager.home(), element: <MainPage /> },
  { path: urlManager.signIn(), element: <SignInPage /> },
  { path: urlManager.signUp(), element: <SignUpPage /> },
  { path: urlManager.signOut(), element: <SignOutPage /> },
  { path: urlManager.forgotPassword(), element: <ForgotPasswordPage /> },
  { path: urlManager.recoveryPassword(), element: <RecoveryPasswordPage /> },
  { path: urlManager.admin().root(), element: <AdminPage /> },
  { path: urlManager.admin().users(), element: <AdminUsersPage /> },
];

export default routes;
